<template>
  <div class="container py-1">
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <a-input-search
          placeholder="请输入区域或地址开始查询资产"
          style="width: 50%"
          v-model="address"
          @search="onSearch"
          :allowClear="true"
        />
        <standard-form-row
          title="房源位置"
          block
          style="padding-bottom: 11px; padding-top: 20px"
        >
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="district">
              <tag-select-option value="11">上海市区</tag-select-option>
              <tag-select-option value="22">金山区</tag-select-option>
            </tag-select>
          </a-form-item>
          <a-form-item v-show="districtList.includes('22')">
            <tag-select v-model="town">
              <tag-select-option value="1">朱泾镇</tag-select-option>
              <tag-select-option value="2">枫泾镇</tag-select-option>
              <tag-select-option value="3">张堰镇</tag-select-option>
              <tag-select-option value="4">亭林镇</tag-select-option>
              <tag-select-option value="5">吕巷镇</tag-select-option>
              <tag-select-option value="6">廊下镇</tag-select-option>
              <tag-select-option value="7">金山卫镇</tag-select-option>
              <tag-select-option value="8">漕泾镇</tag-select-option>
              <tag-select-option value="9">山阳镇</tag-select-option>
              <tag-select-option value="10">石化街道</tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="房屋类型" block style="padding-bottom: 11px">
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="houseType">
              <tag-select-option value="1">商铺</tag-select-option>
              <tag-select-option value="2">写字楼</tag-select-option>
              <tag-select-option value="3">综合体</tag-select-option>
              <tag-select-option value="4">厂房</tag-select-option>
              <tag-select-option value="5">其他商业</tag-select-option>
              <tag-select-option value="6">住宅</tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>

        <standard-form-row title="房屋面积" block style="padding-bottom: 11px">
          <a-form-item style="margin-top: -4px">
            <tag-select v-model="floorSpace">
              <tag-select-option value="1">＜100㎡</tag-select-option>
              <tag-select-option value="2">100-300㎡</tag-select-option>
              <tag-select-option value="3">300-500㎡</tag-select-option>
              <tag-select-option value="4">500-1000㎡</tag-select-option>
              <tag-select-option value="5">＞1000㎡</tag-select-option>
            </tag-select>
          </a-form-item>
        </standard-form-row>
      </a-form>
    </a-card>
    <div style="display: flex;">
    <!-- 左侧列表容器 -->
    <div
      style="width: 350px; display: flex; flex-direction: column; height: 800px;padding: 0px 2px;"
    >
      <!-- 滚动区域 -->
      <div style="flex: 1; overflow-y: auto; padding: 2px;">
        <a-list
          v-if="paginatedList.length > 0"
          :data-source="paginatedList"
          item-layout="vertical"
          size="small"
          split
          :bordered="true"
          
        >
          <a-list-item
            v-for="item in paginatedList"
            :key="item.id"
            @mouseenter="highlight(item.id)"
            @mouseleave="unhighlight(item.id)"
            class="clickable-item"
          >
          <!-- 跳转到详情页 -->
          <a @click="showDetail(item.id)">
            <a-list-item-meta>
              <template slot="title">
                <div
                  class="house-title"
                  :title="item.data.address"
                >
                  {{ item.data.address }}
                </div>
              </template>
              <template slot="description">
                <div style="color: #555; font-size: 13px;">
                  类型：{{ formatType(item.data.houseType) }}
                </div>
                <div style="color: #555; font-size: 13px;">装修：{{ item.data.decorate }}</div>
              </template>
            </a-list-item-meta>
            </a>
          </a-list-item>
        </a-list>

        <!-- 无资产提示 -->
        <div
          v-else
          style="text-align: center; color: #888; margin-top: 260px; font-size: 14px;"
        >
          当前区域暂无资产
        </div>
      </div>

      <!-- 固定分页 -->
      <div style="padding: 8px 0; text-align: center; border-top: 1px solid #eee;">
        <a-pagination
          v-if="visibleList.length > pageSize"
          :current="currentPage"
          :pageSize="pageSize"
          :total="visibleList.length"
          @change="handlePageChange"
          size="small"
        />
      </div>
    </div>

    <!-- 地图区域 -->
    <TdtMapFind
      ref="mapRef"
      :tk="tk"
      :center="[121.334168, 30.723843]"
      :zoom="15"
      :markers="generateMarker()"
      @visible-update="handleVisibleUpdate"
    />
  </div>
  </div>
</template>

<script>
import TdtMapFind from "@/components/TdtMapFind.vue";
import StandardFormRow from "@/components/StandardFormRow";
import TagSelect from "@/components/TagSelect";
import { listMapAsset } from "@/api/common/common.js";
const TagSelectOption = TagSelect.Option;

export default {
  components: {
    TagSelect,
    TagSelectOption,
    StandardFormRow,
    TdtMapFind,
  },
  data() {
    return {
      tk: "a3789da931616fce36077d6fd5712667",
      markerList: [],
      asset: [],
      district: {}, //房源位置
      districtList: [],
      town: {}, // 金山区内房源位置（子数据）
      townList: [],
      houseType: {}, //房屋类型
      houseTypeList: [],
      floorSpace: {}, //房屋面积
      floorSpaceList: [],
      address: "",
      houseEntity: [],
      //地图点聚合
      map: null,
      markerList: [],
      clusterData: null,
      visibleList: [],
      markerData: [], // 原始资产数据
      currentPage: 1, // 当前页码
      pageSize: 7, // 每页显示数量
    };
  },
  mounted() {
    // this.initMap();
  },
  computed: {
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.visibleList.slice(start, start + this.pageSize);
    },
  },
  watch: {
    district(newVal) {
      this.districtList = this.screen(newVal, this.districtList, ["11", "22"]);
      this.markerClusterer();
    },
    town(newVal) {
      this.townList = this.screen(newVal, this.townList, [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
      ]);
      this.markerClusterer();
    },
    houseType(newVal) {
      this.houseTypeList = this.screen(newVal, this.houseTypeList, [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
      ]);
      this.markerClusterer();
    },
    floorSpace(newVal) {
      this.floorSpaceList = this.screen(newVal, this.floorSpaceList, [
        "1",
        "2",
        "3",
        "4",
        "5",
      ]);
      this.markerClusterer();
    },
  },
  methods: {
    handleVisibleUpdate(list) {
      this.visibleList = list;
      this.currentPage = 1; // 当地图更新时回到第一页
    },
    highlight(id) {
      this.$refs.mapRef?.highlightMarker(id);
    },
    unhighlight(id) {
      this.$refs.mapRef?.resetMarkerIcon(id);
    },
    formatType(type) {
      const map = {
        1: "商铺",
        2: "写字楼",
        3: "综合体",
        4: "厂房",
        5: "其他商业",
      };
      return map[type] || "居住";
    },

    //用于多选框的参数筛选
    screen(newVal, parmList, initList) {
      if (newVal.checked == true) {
        if (newVal.value == "total") {
          parmList = initList;
        } else {
          parmList.push(newVal.value);
        }
      }
      if (newVal.checked == false) {
        if (newVal.value == "total") {
          parmList = [];
        } else {
          parmList = parmList.filter((item) => item !== newVal.value);
        }
      }
      return parmList;
    },
    handlePageChange(page) {
      this.currentPage = page;
    },

    onSearch() {
      //需要改造
      this.markerClusterer();
    },
    showDetail(id) {
      //跳转到详情页
      var assetId = id;

      // 使用 this.$router.resolve 生成带参数的 URL
      let url = this.$router.resolve({
        name: "houseDetail",
        query: { assetId },
      }).href;

      // 使用 window.open 在新标签页中打开 URL
      window.open(url, "_blank");
    },
    //获取地图点需要改造
    generateMarker() {
      const assetData = Array.isArray(this.asset)
        ? this.asset.map((item) => {
            return {
              id: item.id,
              housePic:
                Array.isArray(item.housePic) && item.housePic.length > 0
                  ? item.housePic[0]
                  : "",
              lng: item.longitude,
              lat: item.latitude,
              data: {
                address: item.address || "未知地址",
                houseType: item.houseType ?? "", // 防止 houseType 为 null/undefined
                decorate: item.decoration?.split?.("\r\n")?.[0] || "", // 提取第一行装修信息
                traffic: item.publicTransportion || "",
              },
              icon: require("@/assets/locationMap3.png"),
            };
          })
        : [];
      return assetData;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    padding: 0 8px;
    font-size: 14px;
  }
}

.list-articles-trigger {
  margin-left: 12px;
}
.clickable-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 6px;
  padding: 8px 12px;
}

/* 当鼠标放在整个 item 上时，让标题变色 */
.clickable-item:hover .house-title {
  color: #1677ff;
  text-shadow: 0 0 1px rgba(22, 119, 255, 0.3);
}

/* 点击时更深一点的颜色 */
.clickable-item:active .house-title {
  color: #0958d9;
}

/* 标题默认样式 */
.house-title {
  color: #333;
  font-weight: bold;
  line-height: 1.4;
  transition: color 0.25s ease, text-shadow 0.25s ease;
}
</style>

<style lang="less" scope>
.map {
  #container {
    border-radius: 4px;
    padding: 0px;
    margin: 0px;
    margin-top: 20px;
    width: 100%;
    height: 700px;
  }

  .amap-logo {
    display: none;
    opacity: 0 !important;
  }

  .amap-copyright {
    opacity: 0;
  }
  
}
</style>
